module.exports = __webpack_public_path__ + "img/logo_jaegermeister_white.8be1fdc9.svg";